import React from "react";
import ReactDOM from "react-dom/client";
import { Card, CardContent, Typography, Button, createTheme, ThemeProvider } from "@mui/material";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  AppBar, Box, Toolbar, TextField, useTheme, IconButton,  Menu,
  MenuItem, CssBaseline, Modal
} from "@mui/material";
import Close from '@mui/icons-material/Close';
// Import your report components
import DespatchPlanReport from "./DespatchPlanReport";
import InvoiceReport from "./InvoiceReport";
import DeliverOrderPickListReport from "./DeliverOrderPickListReport";
import PackingListReport from "../../salesmanagement/invoice/PackingListReport";
import PackingListExcelDownload from "../../salesmanagement/invoice/PackingListExcelDownload";
// Define a custom theme with a single primary color
const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    action: {
      hover: "#c5c5c5",
    },
  },
});

const ReportTemplates = ({ handleBackWinderMachineEntry }) => {
  const openReportWindow = (ReportComponent, title) => {
    const reportWindow = window.open("", title, "width=1000,height=800");
    reportWindow.document.title = title;

    // Create a container div inside new window
    const container = reportWindow.document.createElement("div");
    reportWindow.document.body.appendChild(container);

    // Render the React component into the new window
    const root = ReactDOM.createRoot(container);
    root.render(<ReportComponent />);
  };

  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "40px",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Reports Template Page
        </Typography>

        <Card
          style={{
            width: 400,
            borderRadius: "16px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            marginBottom: "20px",
          }}
        >
          <CardContent
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
              Reports Menu
            </h2>

            <Button
              variant="contained"
              color="primary"
              onClick={() => openReportWindow(DespatchPlanReport, "Despatch Plan")}
              fullWidth
            >
              Print Despatch Plan
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() => openReportWindow(InvoiceReport, "Invoice")}
              fullWidth
            >
              Invoice
            </Button>
<Button
              variant="contained"
              color="primary"
              onClick={() => openReportWindow(PackingListReport, "Invoice")}
              fullWidth
            >
              Packing List
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => openReportWindow(PackingListExcelDownload, "Invoice")}
              fullWidth
            >
              Packing List Excel Download
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => openReportWindow(DeliverOrderPickListReport, "Delivery Order")}
              fullWidth
            >
              Delivery Order
            </Button>
             <IconButton onClick={handleBackWinderMachineEntry}>
                            <Close fontSize="inherit" style={{ color: "#2196F3", fontSize: "18px" }} />
                          </IconButton>
          </CardContent>
        </Card>
      </div>
    </ThemeProvider>
  );
};

export default ReportTemplates;